import { matchPath } from 'react-router';
import type { Location } from 'react-router';
import { createSelector } from 'reselect';

import { PATH } from 'constants/RoutesConstants';

import type { PreviousRouterLocation, RouterState } from './types';

type State = { router: RouterState };

const EMPTY_LOCATION: Location = { pathname: '', search: '', hash: '', state: null, key: 'default' };

const getRoot = (state: State): RouterState => state.router;

export const getLocation = createSelector(getRoot, ({ location }) => location ?? EMPTY_LOCATION);

const getPreviousLocations = createSelector(getRoot, ({ previousLocations }) => previousLocations);
export const getPreviousLocation = createSelector(
  getPreviousLocations,
  (previousLocations: PreviousRouterLocation[]) => previousLocations[1]?.location ?? EMPTY_LOCATION
);

export const isFirstRendering = createSelector(
  getPreviousLocations,
  getLocation,
  (previousLocations, location) =>
    previousLocations.length === 0 ||
    (previousLocations.length === 1 && previousLocations[0].location.key === location.key)
);

export const isSelfServiceStats = createSelector(getLocation, location => [
  PATH.SELF_SERVICE_STATS_DASHBOARD.path,
  PATH.SELF_SERVICE_STATS_DETAILS.path,
  PATH.MANUFACTURER_STATS_SELF_SERVICE.path,
  PATH.MANUFACTURER_STATS_SELF_SERVICE_DETAILS.path,
].some(path => matchPath(path, location.pathname)));

export const isSelfServiceStatsDetails = createSelector(getLocation, location => [
  PATH.SELF_SERVICE_STATS_DETAILS.path,
  PATH.MANUFACTURER_STATS_SELF_SERVICE_DETAILS.path
].some(path => matchPath(path, location.pathname)));

export const isGroupManagement = createSelector(getLocation, location =>
  location.pathname.includes(PATH.GROUP_MANAGEMENT.path));
